import React from 'react';
import { useParams } from 'react-router-dom';
import PageBlocks from '../components/PageBlocks';
import { isValidLocale } from '../i18n';

/**
 * AboutPage — fully migrated to the Block CMS (iter21).
 * Content is editable from the admin visual editor at /admin/pages/about.
 * If admin disables `replaces_default_content` from the classic editor's settings,
 * PageBlocks will render nothing for unknown setting state and the page goes
 * back to admin-controlled blocks anyway — the prior hardcoded fallback was
 * removed in favor of a single source of truth (the CMS).
 */
export default function AboutPage() {
  const { lang } = useParams();
  const locale = lang && isValidLocale(lang) ? lang : 'es';
  return (
    <div data-testid="about-page" data-locale={locale}>
      <PageBlocks pageKey="about" />
    </div>
  );
}
